namespace Areas.Ucla {
    "use strict";

    export function newDaUclaIndividualRecord(e: any) {
        const dataGrid = e.component;
        e.data.daUclaId = dataGrid.option("DaUclaId");
    }

    export function displayIndividualFullNameExpression(data: any): string {
        if (data) {
            return data.firstName + " " + data.lastName;
        }

        return "Select ...";
    }

    export function onIndividualGridPopupShowing(e: any) {
        const items = e.component.option("toolbarItems");

        const saveButtonIndex = 0;
        const cancelButtonIndex = 1;
        const saveButton = items[saveButtonIndex];
        const cancelButton = items[cancelButtonIndex];

        const grid: any = $("#IndividualGrid").dxDataGrid("instance");
        
        cancelButton.options.elementAttr = { class: "cancel" };
        cancelButton.options.icon = "revert";
        cancelButton.options.onClick = grid.cancelEdit;

        saveButton.options.type = "success";
        saveButton.options.icon = "save";
        saveButton.options.onClick = grid.saveRow;
        
        e.component.option("toolbarItems", items);
    }
}